<template>
  <b-container>
    <h2>{{ $t("titles.declaraties") }}</h2>
    <div class="form-row">
      <div class="col-3">
        <label>{{ $t("labels.declaratiename") }}</label>
      </div>
      <div class="col">
        <label>{{ $t("labels.purchase") }}</label>
      </div>
      <div class="col">
        <label>{{ $t("labels.sale") }}</label>
      </div>
    </div>
    <div v-for="declaratie in declaraties" v-bind:key="declaratie.id">
      <div class="form-row" v-if="declaratie.type != 'total'">
        <div class="col-3">
          <label>{{ declaratie_by_id(declaratie.id).name }}</label>
        </div>
        <div class="col">
          <b-form-input
            type="number"
            class="form-control"
            v-model="
              values.filter((v) => v.declaratie_id == declaratie.id)[0].purchase
            "
          />
        </div>
        <div class="col">
          <b-form-input
            type="number"
            class="form-control"
            v-model="
              values.filter((v) => v.declaratie_id == declaratie.id)[0].sale
            "
          />
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";

export default {
  name: "companydeclaratiedefault",
  data() {
    return {
      a: null,
      values: [],
    };
  },
  props: {
    company_id: Number,
  },
  mounted() {
    this.declaraties.forEach((d) => {
      if (d.type != "total") {
        let filledcd = this.companydeclaraties.filter(
          (cd) => cd.company_id == this.company_id && cd.declaratie_id == d.id
        );
        if (filledcd.length == 0) {
          this.values.push({
            id: 0,
            declaratie_id: d.id,
            sale: 0,
            purchase: 0,
            company_id: this.company_id,
          });
        } else {
          this.values.push(filledcd[0]);
        }
      }
    });
  },
  computed: {
    company() {
      return this.company_id > 0
        ? this.company_by_id(this.company_id)
        : this.company_new;
    },
    ...mapGetters([
      "user_metas",
      "company_by_id",
      "activebranches",
      "user_new",
      "tag_by_id",
      "company_new",
      "declaratie_by_id",
    ]),
    ...mapState([
      "companies",
      "branches",
      "avatars",
      "tags",
      "declaraties",
      "companydeclaraties",
    ]),
  },
  methods: {
    async savedata() {
      console.log("save ", this.values);
      for (let index = 0; index < this.values.length; index++) {
        const c = this.values[index];
        await axios.put("/api/companydeclaratie/" + c.id, c);
      }
      this.$store.dispatch("get_companydeclaraties");
    },
  },
};
</script>
